import React, { useState, useEffect } from "react";
import {
    Card,
    CardContent,
    CardHeader,
    Typography,
    TextField,
    Button,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    OutlinedInput,
    Checkbox,
    ListItemText,
} from "@mui/material";
import '../../Style/InsertNewOrdinanceUserStyle.scss'
import authHeader from "../../Auth/authHeader";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import Autocomplete from '@mui/material/Autocomplete';

export default function InsertNewOrdinanceUser() {
    const headers = authHeader();


    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [companyID, setCompanyID] = useState(0);
    const [roleName, setRoleName] = useState("");
    const [selectedModules, setSelectedModules] = useState([]);

    const [isExtended, setIsExtended] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);



    const [companies, setCompanies] = useState([]);
    const [roles, setRoles] = useState([]);
    const [modules, setModules] = useState([]);



    const handleCreateUser = (event) => {
        event.preventDefault();
        const stateData = {
            Email: email,
            Password: password,
        };
        if (password.length < 8) {
            errorAlert("Fjalëkalimi duhet të jetë të paktën 8 karaktere.");
        } else {
            errorAlert("");
        }

        axios.post(ApiLink.API_URL + 'UsersManagement/createNewUser', stateData, { headers })
            .then((response) => {
                handleSuccess("Llogaria u krijua me sukses");
                setIsExtended(true);
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.errors) {
                    errorAlert(error.response.data.errors.join("\n"));
                } else {
                    errorAlert("Ndodhi një gabim i papritur.");
                }
            });
    };

    const handleupdateRoleAndModule = async (event) => {
        event.preventDefault();

        const payload = {
            email: email,
            role: roleName,
            modules: selectedModules
        };

        try {
            // 1. fillimisht updateUserCompany
            await axios.put(
                ApiLink.API_URL + "UsersManagement/updateUserCompany",
                {},
                { headers, params: { id: companyID, userName: email } }
            );

            // 2. pastaj assignRoleAndModules
            await axios.post(
                ApiLink.API_URL + "UsersManagement/NewassignRoleAndModules",
                payload,
                { headers }
            );

            handleSuccess("Te dhenat u ekzekutuan me sukses");
            setIsSuccess(true);
        } catch (error) {
            errorAlert(error.response?.data || "Error during execution of one or both endpoints");
        }
    };


    //Per ta zgjedhur kompanin
    const handleAutocompleteChangeCompany = (event, value) => {
        if (value) {
            setCompanyID(value.CompanyID);
            // fetchCompanyUnitByID(value.CompanyID);
            // fetchPaymentsAccount(value.CompanyID);
        } else {
            setCompanyID("");
        }
    };

    const defaultPropsCompany = {
        options: companies,
        getOptionLabel: (option) => option.CompanyName || ""
    };


    useEffect(() => {
        axios.get(ApiLink.API_URL + 'companies/getOrdinanceCompanies', { headers })
            .then((response) => {
                setCompanies(response.data);
            })
            .catch((error) => {
                errorAlert(error);
            });
    }, []);

    useEffect(() => {
        axios.get(ApiLink.API_URL + 'UsersManagement/getAllRoles', { headers })
            .then((response) => {
                setRoles(response.data);
            })
            .catch((error) => {
                errorAlert(error);
            });
    }, []);

    useEffect(() => {
        axios.get(ApiLink.API_URL + 'PackContoller', { headers, params: { type: "modul" } })
            .then((response) => {
                setModules(response.data);
            })
            .catch((error) => {
                errorAlert(error);
            });
    }, []);

    return (
        <Card className="user-form" style={{ marginTop: "50px" }}>
            <Typography variant="h5" >Krijo llogari të re</Typography>
            <CardContent>
                <form
                    onSubmit={isExtended ? handleupdateRoleAndModule : handleCreateUser}
                    className="form-content"
                >
                    <div className="form-group">
                        <TextField
                            fullWidth
                            label="Email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={isExtended}
                            autoComplete="new-email"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            fullWidth
                            label="Password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={isExtended}
                            autoComplete="new-email"
                            required
                        />
                    </div>

                    {isExtended && (
                        <div className="extended-section">
                            <Autocomplete fullWidth
                                {...defaultPropsCompany}
                                id="include-input-in-list"
                                includeInputInList
                                onChange={handleAutocompleteChangeCompany}
                                renderInput={(params) => (
                                    <TextField {...params}
                                        label="Zgjedh Kompanin"
                                        variant="standard" />
                                )}
                            />

                            <FormControl fullWidth>
                                <InputLabel>Role</InputLabel>
                                <Select
                                    value={roleName}
                                    onChange={(e) => setRoleName(e.target.value)}
                                    input={<OutlinedInput label="Role" />}
                                    required
                                >
                                    {roles.map((r) => (
                                        <MenuItem key={r.Id} value={r.Name}>
                                            {r.Name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl fullWidth>
                                <InputLabel>Modules</InputLabel>
                                <Select
                                    multiple
                                    value={selectedModules}
                                    onChange={(e) => setSelectedModules(e.target.value)}
                                    input={<OutlinedInput label="Modules" />}
                                    renderValue={(selected) =>
                                        modules
                                            .filter((m) => selected.includes(m.PackName))
                                            .map((m) => m.PackName)
                                            .join(", ")
                                    }
                                >
                                    {modules.map((m) => (
                                        <MenuItem key={m.PackID} value={m.PackName}>
                                            <Checkbox checked={selectedModules.includes(m.PackName)} />
                                            <ListItemText primary={m.PackName} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    )}

                    <div className="form-actions">
                        {!isExtended ? (
                            <Button type="submit" variant="contained" fullWidth>
                                Ruaj dhe vazhdo
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                disabled={isSuccess}
                            >
                                Ruaj
                                {isSuccess ? "Llogaria u krijua" : ""}
                            </Button>
                        )}
                    </div>
                </form>
            </CardContent>
        </Card>
    );
}
